// Vendor libs
// ------------------------------------

// Angular extensions
import 'angular-hotkeys';
import 'angular-load';
import 'angular-xeditable';
import 'angular-raven';
import 'ui-cropper';
import 'angular-marked';

import clipboardModule from 'angular-clipboard';
import deviceDetector from 'ng-device-detector';
import jsonformatter from 'jsonformatter';
import ngAnimate from 'angular-animate';
import ngCache from 'angular-cache';
import ngFileUpload from 'ng-file-upload';
import ngLoadingBar from 'angular-loading-bar';
import ngRoundProgressbar from 'angular-svg-round-progressbar';
import ngSanitize from 'angular-sanitize';
import ngSmartTable from 'angular-smart-table';
import ngStorage from 'angular-storage';
import ngCookies from 'angular-cookies';
import ngJWT from 'angular-jwt';
import toastr from 'angular-toastr';

// UI Bootstrap components
import uibAccordion from 'angular-ui-bootstrap/src/accordion';
import uibButtons from 'angular-ui-bootstrap/src/buttons';
import uibCollapse from 'angular-ui-bootstrap/src/collapse';
import uibDropdown from 'angular-ui-bootstrap/src/dropdown';
import uibModal from 'angular-ui-bootstrap/src/modal';
import uibTabs from 'angular-ui-bootstrap/src/tabs';
import uibTooltip from 'angular-ui-bootstrap/src/tooltip';
import uiTypeahead from 'angular-ui-bootstrap/src/typeahead';
import uiSelect from 'ui-select';

// Routing
import uiRouter from '@uirouter/angularjs';

// fino shared modules
import '@fino/lib-injection';
import ng1Cache from '@fino/ng1-cache';
import ng1Config from '@fino/ng1-config';

//TODO: this is probably not used anywhere
import ng1Customization from './tenant-customization';
import ng1Environment from '@fino/ng1-environment';
import ng1ErrorHandling from '@fino/ng1-error-handling';
import ng1Filter from '@fino/ng1-filter';
import ng1FloatLabel from '@fino/ng1-float-label';
import ng1FormButton from '@fino/ng1-form-button';
import ng1FormControl from '@fino/ng1-form-control';
import ng1FormFields from '@fino/ng1-form-fields';
import ng1FormValidation from '@fino/ng1-form-validation';
import ng1FreshdeskFaqs from '@fino/ng1-freshdesk-faqs';
import ng1Icon from '@fino/ng1-icon';
import ng1InputLabel from '@fino/ng1-input-label';
import ng1Loading from '@fino/ng1-loading';
import ng1LoadingIndicator from '@fino/ng1-loading-indicator';
import ng1Locale from '@fino/ng1-locale';
import ng1Modal from '@fino/ng1-modal';
import ng1PdfViewer from '@fino/ng1-pdf-viewer';
import ng1PromiseDecorator from '@fino/ng1-promise-decorator';
import ng1Response from '@fino/ng1-response';
import ng1SignaturePad from '@fino/ng1-signature-pad';
import ng1Tracking from '@fino/ng1-tracking';
import ng1Translate from '@fino/ng1-translate';
import ng1Translation from '@fino/ng1-translation';

export default [
  'angularLoad',
  'cfp.hotkeys',
  'ngRaven',
  'xeditable',
  'uiCropper',
  'hc.marked',
  clipboardModule.name,
  deviceDetector,
  jsonformatter,

  ng1Cache,
  ng1Config,
  ngCookies,
  ng1Customization,
  ng1Environment,
  ng1ErrorHandling,
  ng1Filter,
  ng1FloatLabel,
  ng1FormButton,
  ng1FormControl,
  ng1FormFields,
  ng1FormValidation,
  ng1FreshdeskFaqs,
  ng1Icon,
  ng1InputLabel,
  ng1Loading,
  ng1LoadingIndicator,
  ng1Locale,
  ng1Modal,
  ng1PdfViewer,
  ng1PromiseDecorator,
  ng1Response,
  ng1SignaturePad,
  ng1Tracking,
  ng1Translate,
  ng1Translation,
  ngAnimate,
  ngCache,
  ngFileUpload,
  ngJWT,
  ngLoadingBar,
  ngRoundProgressbar,
  ngSanitize,
  ngSmartTable,
  ngStorage,
  toastr,
  uibAccordion,
  uibButtons,
  uibCollapse,
  uibDropdown,
  uibModal,
  uibTabs,
  uiSelect,
  uibTooltip,
  uiRouter,
  uiTypeahead,
];
